// extracted by mini-css-extract-plugin
export default {"socials":"socials__socials__R7szz","social":"socials__social__V46r6","icon":"socials__icon__HEubA","navOpen":"socials__navOpen__Dn2sF"};